import * as React from "react";
import { useSelector } from "react-redux";
import { Button, Menu, MenuItem, IconButton } from "@material-ui/core/";
import useStyles from "./styles";
import { useHistory } from "react-router-dom";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SecurityIcon from "@material-ui/icons/Security";
import { Hidden } from "@material-ui/core";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import '../Admin/TheOilsBabe.css';

const MyAccount = ({ logout, color = "#fff" }) => {
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { user } = useSelector((store) => store);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setDisplayName = () => {
    let name;
    if (user.user.displayName) name = user.user.displayName;
    else if (user.user.name) name = user.user.name;
    else if (user.user.email) name = user.user.email.toLowerCase();
    return name;
  };

  const goToAdmin = () => {
    setAnchorEl(null);
    history.push("/admin");
  };

  const goToProfile = () => {
    setAnchorEl(null);
    history.push("/profil");
  };

  const goToSettings = () => {
    setAnchorEl(null);
    history.push("/settings");
  };

  // Custom media query for 660px - 991px
  const isMidScreen = useMediaQuery('(min-width:660px) and (max-width:991px)');

  if (user.user.email) {
    return (
      <>
        {/* Show icon only for 660px-991px */}
        {isMidScreen ? (
          <IconButton
            id="basic-button"
            variant="outlined"
            aria-haspopup="true"
            onClick={handleClick}
            className={classes.button}
            size="large"
            style={{ color }}
          >
            <PersonIcon />
          </IconButton>
        ) : (
          <>
            <Hidden smDown>
              <Button
                id="basic-button"
                variant="outlined"
                aria-haspopup="true"
                onClick={handleClick}
                className={classes.button}
                size="large"
                style={{ color }}
              >
                {`${setDisplayName()}`}
              </Button>
            </Hidden>
            <Hidden smUp>
              <IconButton
                id="basic-button"
                variant="outlined"
                aria-haspopup="true"
                onClick={handleClick}
                className={classes.button}
                size="medium"
                style={{ color }}
              >
                <PersonIcon />
              </IconButton>
            </Hidden>
          </>
        )}
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          className={classes.modernMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          style={{ 
            zIndex: 1200,
            marginTop: 8
          }}
          PaperProps={{
            style: {
              backgroundColor: 'var(--surface-color, #ffffff)',
              color: 'var(--text-primary, #333333)',
              borderRadius: '12px',
              boxShadow: '0 8px 32px rgba(144, 77, 113, 0.15)',
              border: '1px solid var(--border-color, #e7dedf)',
              minWidth: '200px',
            }
          }}
        >
          {(user.user.email === process.env.REACT_APP_ADMIN || user.user.email === process.env.REACT_APP_ARI_ADMIN) && (
            <MenuItem 
              onClick={() => goToAdmin()} 
              className={`${classes.adminMenuItem} nav-link-oils`}
              style={{
                padding: '12px 20px',
                fontSize: '0.95rem',
                backgroundColor: 'transparent',
                color: 'var(--text-primary, #333333)',
                borderRadius: '8px',
                margin: '4px 8px',
                transition: 'all 0.3s ease'
              }}
            >
              <SecurityIcon style={{ fontSize: '18px', marginRight: '12px', color: 'var(--primary-color, #904d71)' }} />
              Admin
            </MenuItem>
          )}
          <MenuItem 
            onClick={() => goToProfile()} 
            className={`${classes.menuItem} nav-link-oils`}
            style={{
              padding: '12px 20px',
              fontSize: '0.95rem',
              backgroundColor: 'transparent',
              color: 'var(--text-primary, #333333)',
              borderRadius: '8px',
              margin: '4px 8px',
              transition: 'all 0.3s ease'
            }}
          >
            <PersonIcon style={{ fontSize: '18px', marginRight: '12px', color: 'var(--primary-color, #904d71)' }} />
            Profil
          </MenuItem>
          <MenuItem 
            onClick={() => goToSettings()} 
            className={`${classes.menuItem} nav-link-oils`}
            style={{
              padding: '12px 20px',
              fontSize: '0.95rem',
              backgroundColor: 'transparent',
              color: 'var(--text-primary, #333333)',
              borderRadius: '8px',
              margin: '4px 8px',
              transition: 'all 0.3s ease'
            }}
          >
            <SettingsIcon style={{ fontSize: '18px', marginRight: '12px', color: 'var(--primary-color, #904d71)' }} />
            Setări
          </MenuItem>
          <MenuItem 
            onClick={logout} 
            className={`${classes.logoutMenuItem} nav-link-oils`}
            style={{
              padding: '12px 20px',
              fontSize: '0.95rem',
              backgroundColor: 'transparent',
              color: 'var(--error-color, #c73e1d)',
              borderRadius: '8px',
              margin: '4px 8px',
              borderTop: '1px solid var(--border-color, #e7dedf)',
              marginTop: '8px',
              paddingTop: '16px',
              transition: 'all 0.3s ease'
            }}
          >
            <ExitToAppIcon style={{ fontSize: '18px', marginRight: '12px', color: 'var(--error-color, #c73e1d)' }} />
            Deconectare
          </MenuItem>
        </Menu>
      </>
    );
  }

  return (
    <Button
      id="basic-button"
      variant="outlined"
      aria-haspopup="true"
      onClick={() => history.push("/login")}
      className={classes.button}
      size="large"
      style={{ color }}
    >
      <PersonIcon />
    </Button>
  );
};

export default MyAccount;
